module.exports = __webpack_public_path__ + "static/media/wa-background.102774f7.png";